import appStore from 'store';
import api from './api';
import { PAGINATION } from './constants.js';

const store = {
  namespaced: true,
  state: {
    currencies: [],
    pagination: PAGINATION,
    totalCount: 0,
    coinList: []
  },
  getters: {},
  mutations: {
    setCurrencyList(state, payload) {
      state.currencies = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    }
  },
  actions: {
    list({ commit }, query) {
      return api.getList(query).then(({ data }) => {
        commit('setCurrencyList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    listAllCoin({ commit }) {
      api.getAllCoin().then(({ data }) => {
        commit('setCoinList', data);
      });
    },
    cancel(context, data) {
      return api.cancel(data);
    },
    refresh(context, data) {
      return api.refresh(data);
    }
  }
};

appStore.registerModule('order', store);
